import * as actions from './actions/index';
import * as model from './model';
import * as selectors from './selectors';
import reducer from './reducer';

export default reducer;
export { actions, model, selectors };
